import Announcements from './Announcements.container';

// announcements list
import './ANGSearchOptIn';
import './ANGSearchOptOut';
import './ANGTemporarilyDisabled';

export default Announcements;
